import React from 'react';
import { connect } from 'react-redux';
import { Tabs } from '@material-ui/core';
import {withGetScreen} from 'react-getscreen';
import {INSIGHTS_PATH} from '../../../constants/paths';
import StyledSecondaryNavLink from '../../common/Buttons/StyledSecondaryNavLink';
import { Configuration } from '../../../configs/Configuration';

class InsightsTopNavigation extends React.Component {
  constructor(props){
    super(props);

    this.state = {
        insightsMenuItems: []
    }
    this.configColors = Configuration.getColors().colors;
  }

  componentWillMount(){
    const { USAGE, MONTHLY_SUMMARY, SIMILAR_HOMES, BILL_ANALYSIS } = INSIGHTS_PATH;
    const insightsNavItems = { 
        usage : {
          name: this.props.translationsData["INSIGHTS_MENU_ITEM.USAGE"],
          to: USAGE
        },
        monthlySummary : {
          name: this.props.translationsData["INSIGHTS_MENU_ITEM.MONTHLY_SUMMARY"],
          to: MONTHLY_SUMMARY
        },
        shc : {
          name: this.props.translationsData["INSIGHTS_MENU_ITEM.SHC"],
          to: SIMILAR_HOMES
        },
        billAnalysis : {
          name: this.props.translationsData["INSIGHTS_MENU_ITEM.BILL_ANALYSIS"],
          to: BILL_ANALYSIS
        }
      };    
    let menuItems = [];
    JSON.parse(this.props.configsData.insightsTopNavItems).map(item =>{
        menuItems.push(insightsNavItems[item]);
    })
    this.setState({
        insightsMenuItems: menuItems
    });
  }

  render() {
    return(
        <Tabs variant="scrollable" scrollButtons="on" value={false}>
            {
                this.state.insightsMenuItems.map( (item, index) => {
                    return <StyledSecondaryNavLink key={index} name={item.name} to={item.to} configColors={this.configColors} />
                })
            }
        </Tabs>
    );
  }
};

const mapStateToProps = state => {
    return {
        configsData : state.configs.data,
        translationsData : state.translationsData.data
    }
};

export default connect(mapStateToProps)(withGetScreen(InsightsTopNavigation));
